/* eslint-disable import/prefer-default-export */
export const StateKey = {
  BulkImportState: 'BulkImportState',
};
